import MobileGNB from './MobileGNB';

/**
 * 모바일 상단 네비게이션 컨테이너.
 * 띠배너·GNB가 부모 flex 기둥(LayoutChildrenWrapper)의 직접 flex item이 되도록 display:contents를 쓴다.
 * 이렇게 해야 sticky GNB의 containing block이 페이지 전체 높이가 되어 스크롤 내내 상단에 고정된다.
 * GNB가 흐름 안에 있어 별도 spacer로 높이를 예약할 필요가 없다.
 */
const RenewalTopNavBar = () => {
  return (
    <div className="contents sm:hidden">
      <MobileGNB />
    </div>
  );
};

export default RenewalTopNavBar;
